import "./headerStyle.css";
import { IHeader } from "../../interfaces/header";
import { FaPhone } from "react-icons/fa";

const Header = (props: IHeader) => {
  const handleCall = () => {
    window.location.href = "tel:8015501123";
  };

  return (
    <>
      <div style={{ backgroundImage: `url(${props.img})` }} className="header">
        <div className="container-1200 font-16-bold">
          <div className="header-box">
            <div className="font-64-bold">{props.title}</div>
            <div className="font-64-bold">{props.secondTitle}</div>
            <div className="font-32-bold">{props.subtitle}</div>
            <div className="subtext">{props.text}</div>
            <div className="subtext">{props.secondText}</div>
            <div className="pb-1"></div>
            <div className="btn black-btn" onClick={handleCall}>
              CONTACT US{" "}
              <span
                role="img"
                aria-label="phone"
                style={{ paddingLeft: "0.25rem" }}
              >
                <FaPhone size={12} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
